import { createContext, useRef } from "react";

export const references = createContext();

export default function References ({children}) {
    const SerialInput = useRef(null);
    const SearchInput = useRef(null);
    const CashingBtn = useRef(null);

    const parent = {
        SerialInput,
        SearchInput,
        CashingBtn
    };

    return <references.Provider value={parent}>{children}</references.Provider>
}